import PropTypes from 'prop-types';
import React from 'react';

import classnames from 'classnames/bind';
import IconContainer from 'presentation/components/icons/IconContainer';

import styles from 'presentation/components/styles/ChatIcon.css';
let cx = classnames.bind(styles);

export default function ChatIcon({ title }) {
  ChatIcon.propTypes = {
    title: PropTypes.string.isRequired,
  };

  let innberBubbleClasses = cx('chatIcon_customFillColors', 'chatIcon_innerBubble', 'chatIcon');
  let innerBubbleLinesClasses = cx('chatIcon_customStrokeColors', 'chatIcon_innerBubble_lines', 'chatIcon');

  return (
    <IconContainer viewBox="0 0 24 24" className={styles.chatIcon} title={title} titleId="minimizedChatTitleId">
      <g
        id="End-to-End-v2"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        className={innberBubbleClasses}
      >
        <g id="2-v2" transform="translate(-1201.000000, -946.000000)">
          <g id="Group-4" transform="translate(1189.000000, 933.000000)">
            <g id="client-chat-icon" transform="translate(12.000000, 13.000000)">
              <rect
                id="Rectangle-2-Copy"
                x="0.734693878"
                y="0.693877551"
                width="22.5306122"
                height="18.8851161"
                rx="2"
              />
              <polygon
                id="Path-2-Copy"
                transform="translate(9.405271, 19.251429) scale(-1, 1) translate(-9.405271, -19.251429) "
                points="5.56268222 18.2002304 13.247859 24.0271376 13.2221238 14.4757213"
              />
              <path
                d="M6.7696793,5.96340605 L17.2303207,5.96340605"
                id="Line-2-Copy-2"
                strokeLinecap="square"
                className={innerBubbleLinesClasses}
              />
              <path
                d="M6.7696793,10.0168895 L17.2303207,10.0168895"
                id="Line-2-Copy-3"
                strokeLinecap="square"
                className={innerBubbleLinesClasses}
              />
              <path
                d="M6.7696793,14.070373 L12.4023324,14.070373"
                id="Line-2-Copy-4"
                strokeLinecap="square"
                className={innerBubbleLinesClasses}
              />
            </g>
          </g>
        </g>
      </g>
    </IconContainer>
  );
}
